const PSEvents = require('PSEvents');
const PSState = require('PSState');
const AudioManager = require('AudioManager');
const AudioMap = require('AudioMap');
const PSUIFeatures = require('PSUIFeatures');
const i18n = require('i18n');

cc.Class({
    extends: cc.Component,

    properties: {
        betLabel: cc.Label,

        increaseBetButton: cc.Button,
        decreaseBetButton: cc.Button,
    },

    onDestroy () {
        PSEvents.unsubscribe(PSEvents.COMMON_INITIALIZED, this.commonInitializedHandler);
        PSEvents.unsubscribe(PSEvents.STATE_UPDATED, this.stateUpdatedHandler);
        PSEvents.unsubscribe(PSEvents.FEATURE_STATE_UPDATED, this.featueStateUpdated);
    },

    onLoad () {
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);
        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);

        this.commonInitializedHandler = (data) => { this.setInitData(data) };

        const initData = PSEvents.getLast(PSEvents.COMMON_INITIALIZED);

        if (initData) {
            this.setInitData(initData);
        } else {
            PSEvents.subscribe(PSEvents.COMMON_INITIALIZED, this.commonInitializedHandler);
        }

    },

    enable () {
        this._enabled = true;
        this._updateButtonsState();
    },

    disable () {
        this._enabled = false;
        this._updateButtonsState();
    },

    /**
     * Set initial data for all possible bet levels list and current bet amount
     * @param betLevels {Array}
     * @param betAmount {Number}
     */
    setInitData (data) {
        this.stateUpdatedHandler = (data) => { this._onBetUpdate(data.betAmount); };
        this.featueStateUpdated = () => {
            this._enabled = PSState.isEnabled(PSUIFeatures.BET);
            this._updateButtonsState();
        };

        PSEvents.subscribe(PSEvents.STATE_UPDATED, this.stateUpdatedHandler);
        PSEvents.subscribe(PSEvents.FEATURE_STATE_UPDATED, this.featueStateUpdated);

        const { availableBetAmounts, betAmount } = data;
        this.betLevels = availableBetAmounts;
        this.betAmount = betAmount;

        this._enabled = PSState.isEnabled(PSUIFeatures.BET);
        this._onBetUpdate(data.betAmount, true);
    },

    /**
     * Update the number of bet label, and update the buttons state if needed
     * @param betAmount {Number}
     * @private
     */
    _onBetUpdate (betAmount, isInit = false) {
        const betConvertedString = i18n.formatCurrency(betAmount);

        if (this.betIndex === this.betLevels.indexOf(betAmount)) {
            return;
        }
        if (!isInit) {
            this.audioManager.play(this.audioMap.introBetButton);
        }
        this.betAmount = betAmount;
        this.betIndex = this.betLevels.indexOf(betAmount);
        this.betLabel.string = betConvertedString.replace(/([^\d]+)/, '$1 ')

        this._updateButtonsState();
    },

    _updateButtonsState () {
        if (!this.betLevels) { // means it is not inited yet
            return;
        }
        if (!this._enabled) {
            this.decreaseBetButton.interactable = false;
            this.increaseBetButton.interactable = false;
            return;
        }

        this.decreaseBetButton.interactable = true;
        this.increaseBetButton.interactable = true;
        if (this.betIndex === 0) {
            this.decreaseBetButton.interactable = false;
        } else if (this.betIndex === this.betLevels.length - 1) {
            this.increaseBetButton.interactable = false;
        }
    },

    /**
     * Click handler for increment bet. Should request for bet increment to the engine.
     */
    incrementBetAmount () {
        if (this.betIndex === this.betLevels.length - 1) {
            return;
        }

        this._updateBetLevel(this.betLevels[this.betIndex + 1]);
    },

    /**
     * Click handler for increment bet. Should request for bet decrement to the engine.
     */
    decrementBetAmount () {
        if (this.betIndex === 0) {
            return;
        }

        this._updateBetLevel(this.betLevels[this.betIndex - 1]);
    },

    /**
     * Request bet update to engine. If successful, the _onBetUpdate handler will update the visual state
     * @param betAmount {Number}
     * @private
     */
    _updateBetLevel (betAmount) {
        PSState.set({ betAmount });
    }
});
